const IMAGES = [
  require("../img/sliding/background-1.jpg"),
  require("../img/sliding/background-2.jpg"),
  require("../img/sliding/background-3.jpg"),
  require("../img/sliding/background-4.jpg"),
  require("../img/sliding/background-5.jpg"),
  require("../img/sliding/background-6.jpg"),
  require("../img/sliding/background-7.jpg"),
  require("../img/sliding/background-8.jpg"),
  require("../img/sliding/background-9.jpg"),
  require("../img/sliding/background-10.jpg"),
  require("../img/sliding/background-11.jpg"),
  require("../img/sliding/background-12.jpg"),
  require("../img/sliding/background-13.jpg"),
  require("../img/sliding/background-14.jpg"),
  require("../img/sliding/background-15.jpg"),
  require("../img/sliding/background-16.jpg"),
];
module.exports = IMAGES;
